import React, { useEffect, useState } from 'react';
import axios from 'axios';

const QuizPerformanceChart = () => {
    const [attempts, setAttempts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAttempts = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get('http://localhost:5001/api/users/gamification/stats', {
                    headers: { 'x-auth-token': token }
                });
                setAttempts(res.data.stats.recentAttempts || []);
                setLoading(false);
            } catch (err) {
                console.error(err);
                setLoading(false);
            }
        };

        fetchAttempts();
    }, []);

    if (loading) {
        return (
            <div className="flex min-h-[200px] items-center justify-center">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-indigo-200 border-t-indigo-500" />
            </div>
        );
    }

    if (attempts.length === 0) {
        return (
            <div className="rounded-2xl bg-slate-50 p-8 text-center">
                <div className="text-4xl">📊</div>
                <p className="mt-3 text-slate-600">Chưa có dữ liệu bài kiểm tra</p>
            </div>
        );
    }

    const maxPercentage = 100;

    return (
        <div className="rounded-3xl bg-white/90 p-6 shadow-xl">
            <h3 className="mb-6 flex items-center gap-2 text-lg font-semibold text-slate-900">
                <span>📊</span> Biểu đồ hiệu suất
            </h3>

            <div className="space-y-4">
                {attempts.slice(0, 5).map((attempt, index) => (
                    <div key={index}>
                        <div className="mb-2 flex items-center justify-between">
                            <span className="text-sm font-medium text-slate-700 truncate max-w-[200px]">
                                {attempt.quizTitle}
                            </span>
                            <span className={`text-sm font-bold ${
                                attempt.percentage >= 80 ? 'text-green-600' :
                                attempt.percentage >= 60 ? 'text-yellow-600' :
                                'text-red-600'
                            }`}>
                                {attempt.percentage.toFixed(0)}%
                            </span>
                        </div>
                        <div className="relative h-6 overflow-hidden rounded-full bg-slate-100">
                            <div
                                className={`h-full transition-all duration-500 ${
                                    attempt.percentage >= 80 ? 'bg-gradient-to-r from-green-500 to-emerald-500' :
                                    attempt.percentage >= 60 ? 'bg-gradient-to-r from-yellow-500 to-amber-500' :
                                    'bg-gradient-to-r from-red-500 to-rose-500'
                                }`}
                                style={{ width: `${(attempt.percentage / maxPercentage) * 100}%` }}
                            />
                            <div className="absolute inset-0 flex items-center px-3">
                                <span className="text-xs font-semibold text-white drop-shadow">
                                    {attempt.score}/{attempt.totalPoints}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Performance Summary */}
            <div className="mt-6 grid grid-cols-3 gap-3 rounded-xl bg-slate-50 p-4">
                <div className="text-center">
                    <p className="text-xs text-slate-500">Cao nhất</p>
                    <p className="text-lg font-bold text-green-600">
                        {Math.max(...attempts.map(a => a.percentage)).toFixed(0)}%
                    </p>
                </div>
                <div className="text-center">
                    <p className="text-xs text-slate-500">Trung bình</p>
                    <p className="text-lg font-bold text-indigo-600">
                        {(attempts.reduce((sum, a) => sum + a.percentage, 0) / attempts.length).toFixed(0)}%
                    </p>
                </div>
                <div className="text-center">
                    <p className="text-xs text-slate-500">Thấp nhất</p>
                    <p className="text-lg font-bold text-red-600">
                        {Math.min(...attempts.map(a => a.percentage)).toFixed(0)}%
                    </p>
                </div>
            </div>
        </div>
    );
};

export default QuizPerformanceChart;
